import { render } from "./uploadFiles.vue?vue&type=template&id=42cff38d&scoped=true"
import script from "./uploadFiles.vue?vue&type=script&lang=js"
export * from "./uploadFiles.vue?vue&type=script&lang=js"

import "./uploadFiles.vue?vue&type=style&index=0&id=42cff38d&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cff38d"]])

export default __exports__